import { Helmet } from 'react-helmet';
import WithdrawalTable from '../../components/withdrawals/WithdrawalTable';
import { Link } from 'react-router-dom';

const Withdrawals = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketer Withdrawals - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User withdrawals page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      <div className="withdrawals">
        <h1 className="pageTitle">Withdrawal History</h1>
        <h3 className="subtitle">You can see your withdrawal history and status here</h3>
        <WithdrawalTable />
        <br />
        <Link
          to="/withdrawals/new"
          style={{
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#00bfa6',
            textDecoration: 'none',
            color: '#fff',
            width: '250px',
            textAlign: 'center',
            padding: '10px 0px',
            borderRadius: '15px',
          }}
        >
          Make a new withdrawal
        </Link>
      </div>
    </>
  );
};

export default Withdrawals;
